type EmblemProps = {
  className?: string;
};

/** Coal City Life mark: emerald hex, open "C", glowing coal at the centre. */
export function Emblem({ className }: EmblemProps) {
  return (
    <svg viewBox="0 0 64 64" className={className} role="img" aria-label="Coal City Life">
      <rect width="64" height="64" rx="14" className="fill-surface-container-high" />
      <path
        d="M32 8 52.8 20v24L32 56 11.2 44V20Z"
        fill="none"
        className="stroke-primary-container"
        strokeWidth="4"
        strokeLinejoin="round"
      />
      <path
        d="M40 24.5a11 11 0 1 0 0 15"
        fill="none"
        className="stroke-primary"
        strokeWidth="5"
        strokeLinecap="round"
      />
      <circle cx="32" cy="32" r="3.5" className="fill-secondary" />
    </svg>
  );
}